/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FindingStatus = {
    Unresolved: 'UNRESOLVED',
    Resolved: 'RESOLVED',
    NotApplicable: 'NOT_APPLICABLE'
} as const;
export type FindingStatus = typeof FindingStatus[keyof typeof FindingStatus];

